<template>
  <v-card class="pb-4">
    <v-card-text class="card-text">
      <h4> {{ cardTitle }} </h4>
    </v-card-text>
    <div>
      <v-card-text>
        <div v-bind:key="index" v-for="(endpoint, index) in endpoints">
          <button @click="emitScrollToEndpoint(endpoint.ref)">
            <code v-if="endpoint.verb == 'GET'" style="color: #1b739f;"> {{ endpoint.verb }} </code>
            <code v-else-if="endpoint.verb == 'PUT'" style="color: #fba334;"> {{ endpoint.verb }} </code>
            <code v-else-if="endpoint.verb == 'POST'" style="color: #21765d;"> {{ endpoint.verb }} </code>
            <code v-else-if="endpoint.verb == 'DELETE'" style="color: #fc2403;"> {{ endpoint.verb }} </code>
            <code v-else-if="endpoint.verb == 'PATCH'" style="color: #e56f4a;"> {{ endpoint.verb }} </code>
            <code> {{ endpoint.path }} </code>
            <p></p>
          </button>
        </div>
      </v-card-text>
    </div>
  </v-card>
</template>
<script>
export default {
  props: ["cardTitle", "endpoints"],
  methods: {
    emitScrollToEndpoint(refName) {
      this.$root.$emit("scrollToEndpoint", refName);
    },
  },
};
</script>
<style scoped>
  code {
    background-color: inherit !important;
    font-size: 1rem;
    word-break: break-all;
  }

  v-card {
    display: block;
    width: 100%;
    color: #f7fafc;
  }

  .card-text {
    background: #e3e8ee;
  }

  h4 {
    color: #8992a2;
  }
</style>